export default __webpack_public_path__ + "static/media/camera.36d3ecfe.png";